import {
	EmailFieldRHF,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormPasswordFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface INetSuiteSetupFieldsLeftPanel {
}
export const NetSuiteSetupFieldsLeftPanel: FC<
	INetSuiteSetupFieldsLeftPanel
> = ({ }) => {

	return (
		<>
			<EnhancedDropDownRHFWithLabel
				label="Authentication Mode"
				selectName="authenticationMode"
				testId="authentication-mode"
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Basic", value: 100 },
					{ label: "Token Based", value: 200 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EmailFieldRHF
				label="Email"
				id="email"
				testId={`netsuite-setup-email`}
				labelPosition={LabelPosition.Top}
				labelColumns={4}
				fieldColumns={8}
			// required
			/>
			<RHookFormPasswordFieldWithLabel
				id="password"
				testId={`password`}
				label="Password"
				labelPosition={LabelPosition.Top}
			// required
			/>
			<RHookFormTextFieldWithLabel
				label="Account Number"
				id="accountNumber"
				testId={`account-number`}
				labelPosition={LabelPosition.Top}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Account Type"
				selectName="accountType"
				testId="accoutn-type"
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "NetSuite", value: 100 },
					{ label: "NetSuite - OneWorld", value: 200 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
		</>
	);
};
